import _ from "lodash";
import { PARENT, STAFF, STUDENT } from "Constants/stringConstants";

export const getCoursesCohorts = _.memoize(
  (courses, skipNodeExtraction = false) => {
    const coursesCohorts = [];
    _.forEach(courses, course => {
      const {
        students = {},
        collaborator = {},
        familyMembers = {},
        id,
        title,
      } = skipNodeExtraction ? course : _.get(course, "node", {});
      const studentsList = _.map(_.get(students, "edges", []), "node");
      const collaboratorList = _.map(_.get(collaborator, "edges", []), "node");
      const familyMembersList = _.map(
        _.get(familyMembers, "edges", []),
        "node"
      );

      if (!_.isEmpty(studentsList)) {
        coursesCohorts.push({
          id,
          title,
          type: STUDENT,
          userList: studentsList,
        });
      }
      if (!_.isEmpty(collaboratorList)) {
        coursesCohorts.push({
          id,
          title,
          type: STAFF,
          userList: collaboratorList,
        });
      }
      if (!_.isEmpty(familyMembersList)) {
        coursesCohorts.push({
          id,
          title,
          type: PARENT,
          userList: familyMembersList,
        });
      }
    });
    return coursesCohorts;
  }
);

export const getYearGroupCohorts = _.memoize(yearGroups => {
  const yearGroupsCohorts = [];
  _.forEach(yearGroups, yearGroup => {
    const {
      allStudents = [],
      allStaffs = [],
      allParents = [],
      id,
      name: title,
    } = yearGroup;

    if (!_.isEmpty(allStudents)) {
      yearGroupsCohorts.push({
        id,
        title,
        type: STUDENT,
        userList: allStudents,
      });
    }
    if (!_.isEmpty(allStaffs)) {
      yearGroupsCohorts.push({
        id,
        title,
        type: STAFF,
        userList: allStaffs,
      });
    }
    if (!_.isEmpty(allParents)) {
      yearGroupsCohorts.push({
        id,
        title,
        type: PARENT,
        userList: allParents,
      });
    }
  });
  return yearGroupsCohorts;
});

export const getGradesCohorts = _.memoize(grades => {
  const gradeCohorts = [];
  _.forEach(grades, grade => {
    const {
      allStudents = [],
      allStaffs = [],
      allParents = [],
      id,
      name: title,
    } = grade;

    if (!_.isEmpty(allStudents)) {
      gradeCohorts.push({
        id,
        title,
        type: STUDENT,
        userList: allStudents,
      });
    }
    if (!_.isEmpty(allStaffs)) {
      gradeCohorts.push({
        id,
        title,
        type: STAFF,
        userList: allStaffs,
      });
    }
    if (!_.isEmpty(allParents)) {
      gradeCohorts.push({
        id,
        title,
        type: PARENT,
        userList: allParents,
      });
    }
  });
  return gradeCohorts;
});
